export default {"src":"/_next/static/media/shiny.3c7cdd2f.svg","height":1565,"width":1579,"blurWidth":0,"blurHeight":0};